import { render, staticRenderFns } from "./ThumbAction.vue?vue&type=template&id=0cc02098&scoped=true&"
import script from "./ThumbAction.vue?vue&type=script&lang=js&"
export * from "./ThumbAction.vue?vue&type=script&lang=js&"
import style0 from "./ThumbAction.vue?vue&type=style&index=0&id=0cc02098&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc02098",
  null
  
)

export default component.exports